"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumHierarchicalGroupingRule = void 0;
const project_1 = require("../../project");
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class AltiumHierarchicalGroupingRule {
    constructor(config) {
        this.config = config;
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, hierarchy) {
        if (this.config.mode === project_1.HierarchyMode.Hierarchical || this.config.mode === project_1.HierarchyMode.StrictHierarchical) {
            this.mergeHierarchicalPortsRecursively(manager, hierarchy, undefined);
        }
        return manager;
    }
    mergeHierarchicalPortsRecursively(manager, childHierarchy, parentHierarchy) {
        if (parentHierarchy) {
            this.mergeHierarchicalPorts(manager, parentHierarchy, childHierarchy);
        }
        for (const child of childHierarchy.children) {
            this.mergeHierarchicalPortsRecursively(manager, child, childHierarchy);
        }
    }
    mergeHierarchicalPorts(manager, parentHierarchy, childHierarchy) {
        const childSheetSymbol = childHierarchy.instance.sheetSymbol;
        if (!childSheetSymbol) {
            return;
        }
        const sheetSymbolFileName = childSheetSymbol.getFileNameText();
        const sheetSymbolName = childSheetSymbol.getSheetNameText();
        const childPortGroups = manager.findGroupsWithLabel('port', undefined, childHierarchy.instance);
        const parentSheetEntryGroups = manager.findGroupsWithLabel('sheet-entry', undefined, parentHierarchy.instance);
        for (const childGroup of childPortGroups) {
            for (const [instance, nets] of childGroup.getNets()) {
                if (instance.pathUniqueId !== childHierarchy.pathUniqueId) {
                    continue;
                }
                const portLabels = nets.flatMap((net) => net.labels
                    .filter((label) => label.labelType === 'port')
                    .filter((l) => l.strategyMetadata?.['port-metadata']?.pathUniqueId === childHierarchy.pathUniqueId));
                if (!portLabels.length) {
                    continue;
                }
                for (const portLabel of portLabels) {
                    const portMetadata = portLabel.strategyMetadata?.['port-metadata'];
                    if (!portMetadata) {
                        throw new Error(`Port label is missing metadata`);
                    }
                    const portName = portMetadata.portName;
                    const portNameLower = portName.toLowerCase();
                    for (const parentGroup of parentSheetEntryGroups) {
                        for (const [parentInstance, nets] of parentGroup.getNets()) {
                            if (parentInstance.pathUniqueId !== parentHierarchy.pathUniqueId) {
                                continue;
                            }
                            const sheetEntryLabels = nets.flatMap((net) => net.labels
                                .filter((label) => label.labelType === 'sheet-entry')
                                .filter((l) => l.strategyMetadata?.['sheet-entry-metadata']?.parentPathUniqueId ===
                                parentHierarchy.pathUniqueId &&
                                l.strategyMetadata?.['sheet-entry-metadata']?.sheetSymbolUniqueId === childSheetSymbol.uniqueId));
                            if (!sheetEntryLabels.length) {
                                continue;
                            }
                            const hasMatchingSheetEntry = sheetEntryLabels.filter((label) => {
                                if (!label.strategyMetadata?.['sheet-entry-metadata']) {
                                    throw new Error(`Sheet entry label is missing metadata`);
                                }
                                const metadata = label.strategyMetadata['sheet-entry-metadata'];
                                if (!this.harnessMetadataMatches(portLabel, label)) {
                                    return false;
                                }
                                const portRange = portMetadata.busRange;
                                const entryRange = metadata.busRange;
                                if (portRange || entryRange) {
                                    return (portRange !== undefined &&
                                        entryRange !== undefined &&
                                        portRange.declaration.toLowerCase() === entryRange.declaration.toLowerCase() &&
                                        portRange.width === entryRange.width &&
                                        portRange.index === entryRange.index &&
                                        metadata.sheetSymbolFileName === sheetSymbolFileName &&
                                        metadata.sheetSymbolName === sheetSymbolName);
                                }
                                if (metadata.isRepeated) {
                                    return (metadata.sheetSymbolFileName === sheetSymbolFileName &&
                                        metadata.sheetSymbolName === sheetSymbolName &&
                                        metadata.sheetEntryName.toLowerCase() === portNameLower &&
                                        metadata.channelIndex === portMetadata.channelIndex);
                                }
                                return (metadata.sheetSymbolFileName === sheetSymbolFileName &&
                                    metadata.sheetSymbolName === sheetSymbolName &&
                                    metadata.sheetEntryName.toLowerCase() === portNameLower);
                            });
                            if (hasMatchingSheetEntry.length) {
                                manager.mergeGroups(parentGroup, childGroup);
                                break;
                            }
                        }
                    }
                }
            }
        }
    }
    harnessMetadataMatches(portLabel, sheetEntryLabel) {
        const portHarnessMember = portLabel.strategyMetadata?.harness?.harnessMemberName;
        const sheetEntryHarnessMember = sheetEntryLabel.strategyMetadata?.harness?.harnessMemberName;
        if (!portHarnessMember && !sheetEntryHarnessMember) {
            return true;
        }
        if (!portHarnessMember || !sheetEntryHarnessMember) {
            return false;
        }
        return portHarnessMember === sheetEntryHarnessMember || sheetEntryHarnessMember.endsWith(`.${portHarnessMember}`);
    }
}
exports.AltiumHierarchicalGroupingRule = AltiumHierarchicalGroupingRule;
//# sourceMappingURL=AltiumHierarchicalGroupingRule.js.map